import { Contact } from "./contact.model";

export class Lot {
    /** unique internal identity of the lot. */
    public id: number;

    /** Contact associated with the lot. */
    public contact: Contact;

    /** Legal company name of the lot. */
    public name: string;

    /** Preferred, doing business as (dba), name of the lot (if any).*/
    public dbaName: string;

    /** Unique dealer number assigned to the lot. */
    public dealerNumber: string;

    /** A string indicating whether or not the lot is active. */
    public active: string;
}